/**
 * Convertit une chaîne de caractères en camelCase
 * @param str - La chaîne à convertir en camelCase
 * @returns La chaîne convertie en camelCase
 */
export function toCamelCase(str: string): string {
    // Remplacer les caractères non alphanumériques par des espaces
    // puis diviser en mots
    const words = str
      .replace(/[^\w\s]/g, ' ')
      .split(/\s+/);
    
    // Si aucun mot n'est trouvé, retourner une chaîne vide
    if (words.length === 0) return '';
    
    // Premier mot en minuscules
    const firstWord = words[0].toLowerCase();
    
    // Tous les mots suivants avec première lettre en majuscule
    const restWords = words.slice(1).map(word => {
      // Gérer le cas d'une chaîne vide
      if (word.length === 0) return '';
      // Première lettre en majuscule, reste en minuscule
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    
    // Joindre tous les mots
    return firstWord + restWords.join('');
  }

  
/**
 * Convertit une chaîne de caractères en PascalCase
 * @param str - La chaîne à convertir en PascalCase
 * @returns La chaîne convertie en PascalCase
 */
export function toPascalCase(str: string): string {
  // Remplacer les caractères non alphanumériques par des espaces
  // puis diviser en mots
  const words = str
    .replace(/[^\w\s]/g, ' ')
    .split(/\s+/);
  
  // Si aucun mot n'est trouvé, retourner une chaîne vide
  if (words.length === 0) return '';
  
  // Convertir chaque mot avec première lettre en majuscule
  const capitalizedWords = words.map(word => {
    // Gérer le cas d'une chaîne vide
    if (word.length === 0) return '';
    // Première lettre en majuscule, reste en minuscule
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
  
  // Joindre tous les mots
  return capitalizedWords.join('');
}